import React from 'react';
import { ReactComponent as HospitalMapSvg } from 'assets/images/contact/hospital-map.svg';

export const HospitalMap = () => {
    return <HospitalMapSvg className="w-full h-auto" />;
};
